  <section id="hero" >
    <div class="hero-container">
      <div id="heroCarousel" class="carousel slide carousel-fade" data-ride="carousel">
        <ol class="carousel-indicators" id="hero-carousel-indicators"></ol>
        <div class="carousel-inner" role="listbox">
          <div *ngFor="let slide of slideItems"
            class="carousel-item"
            style="background: url(assets/img/slide/{{slide.imageUrl}});"
            [ngClass]="[ slide.orden < 1 ? 'active' : 'none']"
            >
            <div class="carousel-container">
              <div class="carousel-content">
                <span class="animate__animated animate__fadeInDown" style="padding-top:90px; font-size: 18px !important; color:#FDC657;" >Municipalidad Provincial del Cusco</span>
                <br>
                <span class="animate__animated animate__fadeInDown" style="font-size: 22px !important; color:#FDC657;" >"Qosqo Hatun LLaqta"</span>
                <h2 class="animate__animated animate__fadeInDown" [innerHTML]="slide.titulo_1"></h2>
                <p class="animate__animated animate__fadeInUp" [innerHTML]="slide.descripcion"></p>
                <div>
                  <a href="/catalogacion" class="btn-menu animate__animated animate__fadeInUp scrollto">Catalogación</a>
                  <a href="/inmaterial" class="btn-book animate__animated animate__fadeInUp scrollto">Patrimonio Inmaterial</a>
                  <a href="https://centrohistorico.maps.arcgis.com/home/index.html" class="btn-menu animate__animated animate__fadeInUp scrollto" target="_blank">PlanimetrÍa</a>
                  <a href="https://www.youtube.com/channel/UCPaMQnyHK8r6LMt5Ml8nR2w" class="btn-book animate__animated animate__fadeInUp scrollto" target="_blank">Hatun Qosqo</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <a class="carousel-control-prev" href="#heroCarousel" role="button" data-slide="prev">
          <span class="carousel-control-prev-icon icofont-simple-left" aria-hidden="true"><i class="fa fa-angle-left" style="font-size: 24px;"></i></span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#heroCarousel" role="button" data-slide="next">
          <span class="carousel-control-next-icon icofont-simple-right" aria-hidden="true"><i class="fa fa-angle-right" style="font-size: 24px;"></i></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
  </section>






